<!--
 * @Author: shiao
 * @Date: 2020-11-23 13:47:22
 * @LastEditTime: 2021-01-15 17:26:53
 * @LastEditors: shiao
 * @Description: 通用弹窗
 * @FilePath: \o2o-app\src\components\common-pup.vue
-->
<template>
  <div>
      <div class="common-pup-div" v-show="pupshow" :style="{'z-index':Zindex}">
      <div class="common-pup-mask">
        <div class="common-pup-item">
          <div class="common-pup-title" v-show="pup_title"></div>
          <div class="common-pup-content">{{ pup_content }}</div>
          <div class="common-pup-btn">
            <div class="cancel-btn" @click="pupcancel" :style="{'color':pupcancelColor}">{{pupcancelText}}</div>
            <div class="certain-btn" @click="pupcertain" :style="{'color':pupcertainColor}">{{pupcertainText}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        pup_title:{
            type:String,
            default:''
        },
        pup_content:{
            type:String,
            required:true,
        },
        pupshow:{
            type:Boolean,
            required:true,
        },
        pupcancelText:{
            type:String,
            default:'取消'
        },
        pupcertainText:{
            type:String,
            default:'呼叫'
        },
        Zindex:{
          type:Number,
          default:999
        },
        pupcancelColor:{
          type:String,
            default:'#999999;'
        },
        pupcertainColor:{
          type:String,
            default:'#f9591b;'
        },
    },
    methods:{
        pupcancel(){
            this.$emit('pupcancel',false)
        },
        pupcertain(){
            this.$emit('pupcertain',false)
        },
    }
}
</script>

<style lang="less" scoped>
.common-pup-div {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  width: 100%;
  .common-pup-mask {
    background-color: rgba(000, 000, 000, 0.6);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .common-pup-item {
    background-color: #ffffff;
    width: 274px;
    border-radius: 3px;
    overflow: hidden;
    .common-pup-title {
      width: 274px;
      height: 64px;
      font-size: 36px;
      font-weight: 500;
      color: #333333;
      line-height: 50px;
      padding: 40px 24px;
      text-align: center;
    }
    .common-pup-content {
      text-align: center;
      height: 64px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 64px;
      word-break: keep-all;
    }
    .common-pup-btn {
      border-top: 1px solid #e5e5e5;
      display: flex;
      .cancel-btn,
      .certain-btn {
        flex: 1;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
      }
      .cancel-btn {
        font-weight: 400;
      }
      .certain-btn {
        font-weight: 500;
        color: #f9591b;
        line-height: 50px;
        border-left: 1px solid #e5e5e5;
      }
    }
  }
}
</style>
